import * as types from '../constants';

export function resetCreateOrganizationStatus() {
  return {
    type: types.RESET_CREATE_ORGANIZATION_STATUS,
  };
}

export function loadCustomerOrganizationsList() {
  return {
    type: types.LOAD_CUSTOMER_ORGANIZATIONS_LIST,
  };
}

export function loadCustomerOrganizationsListPage(page, searchText) {
  return {
    type: types.LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE,
    page,
    searchText,
  };
}

export function updateCustomerOrganization(data) {
  return {
    type: types.UPDATE_CUSTOMER_ORGANIZATION,
    data,
  };
}

export function loadCustomerSubscriptionPlan(uuid) {
  return {
    type: types.LOAD_CUSTOMER_SUBSCRIPTION_PLAN,
    uuid,
  };
}

export function createCustomerSubscription(data) {
  return {
    type: types.CREATE_CUSTOMER_SUBSCRIPTION,
    data,
  };
}

export function updateCustomerSubscription(data) {
  return {
    type: types.UPDATE_CUSTOMER_SUBSCRIPTION,
    data,
  };
}

export function restrictSubscriptionCustomerOrganization(subscriptionUUID) {
  return {
    type: types.RESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION,
    subscriptionUUID,
  };
}

export function unrestrictSubscriptionCustomerOrganization(subscriptionUUID) {
  return {
    type: types.UNRESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION,
    subscriptionUUID,
  };
}

export function notifySubscriptionRestrictedCustomerOrganization(
  organisationID,
) {
  return {
    type: types.NOTIFY_SUBSCRIPTION_RESTRICTED_CUSTOMER_ORGANIZATION,
    organisationID,
  };
}

export function createCustomerOrganization(data) {
  return {
    type: types.CREATE_CUSTOMER_ORGANIZATION,
    data,
  };
}

export function loadCustomerOrganization(organisationUUID) {
  return {
    type: types.LOAD_CUSTOMER_ORGANIZATION,
    organisationUUID,
  };
}

export function deleteCustomerOrganization(organisationUUID) {
  return {
    type: types.DELETE_CUSTOMER_ORGANIZATION,
    organisationUUID,
  };
}

export function loadCustomerOrganizationUsersList(organisationID) {
  return {
    type: types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST,
    organisationID,
  };
}

export function loadCustomerOrganizationUsersListPage(organisationID, page) {
  return {
    type: types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE,
    organisationID,
    page,
  };
}

export function updateCustomerOrganizationUser(organisationID, uuid, data) {
  return {
    type: types.UPDATE_CUSTOMER_ORGANIZATION_USER,
    organisationID: organisationID,
    uuid: uuid,
    data: data,
  };
}

export function createCustomerOrganizationUser(organisationID, data) {
  return {
    type: types.CREATE_CUSTOMER_ORGANIZATION_USER,
    organisationID: organisationID,
    data: data,
  };
}

export function deleteCustomerOrganizationUser(organisationID, uuid) {
  return {
    type: types.DELETE_CUSTOMER_ORGANIZATION_USER,
    organisationID: organisationID,
    uuid: uuid,
  };
}

export function inviteCustomerOrganizationUser(organisationID, uuid) {
  return {
    type: types.INVITE_CUSTOMER_ORGANIZATION_USER,
    organisationID: organisationID,
    uuid: uuid,
  };
}

export function addFPsCustomerOrganizationUser(organisationID, uuid) {
  return {
    type: types.ADD_FPs_CUSTOMER_ORGANIZATION_USER,
    organisationID: organisationID,
    uuid: uuid,
  };
}

export function transrUserFromOrgtoAnother(uuid, organisationUUID) {
  return {
    type: types.TRANSTER_USER_FROM_ORG_TO_ANOTHER,
    uuid: uuid,
    organisationUUID: organisationUUID,
  };
}

export function loadUsersInfoForStaffMember(text) {
  return {
    type: types.LOAD_USERS_INFO_FOR_STAFF_MEMBER,
    text: text,
  };
}

export function notifySubscriptionExpiredCustomerOrganizationUser(id) {
  return {
    type:
      types.NOTIFY_SUBSCRIPTION_EXPIRED_COMMUNITY_CUSTOMER_ORGANIZATION_USER,
    id: id,
  };
}

export function resetSetOrganizationActiveStatus() {
  return {
    type: types.RESET_SET_ORGANIZATION_ACTIVE_STATUS,
  };
}

export function resetSetOrganizationInactiveStatus() {
  return {
    type: types.RESET_SET_ORGANIZATION_INACTIVE_STATUS,
  };
}

export function setOrganizationActive(organisationUUID, date) {
  return {
    type: types.SET_ORGANIZATION_ACTIVE,
    organisationUUID: organisationUUID,
    date: date,
  };
}

export function setOrganizationInactive(organisationUUID) {
  return {
    type: types.SET_ORGANIZATION_INACTIVE,
    organisationUUID: organisationUUID,
  };
}
